export default __webpack_public_path__ + "static/media/pvilla1-2.f416f95f.webp";